<script>
import M from 'materialize-css'

export default {
  mounted: function () {
    var elems = document.querySelectorAll('.modal')
    M.Modal.init(elems)
  },
  props: {
    button: String,
    header: String,
    id: String,
    onAccept: Function
  },
};
</script>
<template>
  <div v-bind:id="id" class="modal">
    <div class="modal-content">
      <h4>{{ header }}</h4>
      <slot></slot>
    </div>
    <div class="modal-footer">
      <button class="modal-action modal-close waves-effect waves-green btn-flat"
        v-on:click="onAccept">
        {{ button }}
      </button>
    </div>
  </div>
</template>
